import apiFetch from '../apiFetch'

export default function (idCambioEstadoVerraco, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/deleteCambioEstado`, method: 'POST', body: idCambioEstadoVerraco, token: token})
}
